// import React, { useState, useEffect } from 'react';
// import { Link, useLocation } from 'react-router-dom';
// import './Navbar.css';
// import { useProducts } from '../hooks/useProducts';
// import { playSound } from '../utils/productUtils';

// const Navbar = () => {
//   const { products, categories } = useProducts();
//   const [open, setOpen] = useState(false);
//   const [show, setShow] = useState(true); // stato visibilità navbar
//   const [lastScrollY, setLastScrollY] = useState(0);
//   const [activeCategory, setActiveCategory] = useState(null);
//   const location = useLocation();

//   // gestione scroll
//   const controlNavbar = () => {
//     if (window.scrollY === 0) {
//     // Mostra la navbar solo se sei in cima
//     setShow(true);
//   } else if (window.scrollY > lastScrollY) {
//     // Nascondi la navbar quando scendi
//     setShow(false);
//   }
//   // Non ri-mostrare durante la risalita, solo in cima
//   setLastScrollY(window.scrollY);
// };

//   useEffect(() => {
//     window.addEventListener("scroll", controlNavbar);
//     return () => window.removeEventListener("scroll", controlNavbar);
//   }, [lastScrollY]);

//   useEffect(() => {
//     const currentPath = location.pathname.split('/')[1];
//     const currentCategory = categories?.find(
//       (cat) => cat.name.toLowerCase().replace(/\s+/g, '-') === currentPath
//     );
//     setActiveCategory(currentCategory?.id || null);
//   }, [location.pathname, categories]);

//   return (
//     <nav className={`navbar ${show ? "navbar-show" : "navbar-hide"}`}>
//       <div className="menu-icon" onClick={() => setOpen(!open)}>
//         ☰
//       </div>

//       <ul className={`nav-menu ${open ? "active" : ""}`}>
//         <li className="nav-item">
//           <Link to="/"
//             className={`nav-links ${!activeCategory ? 'active' : ''}`}
//             onClick={() => {
//               setActiveCategory(null);
//                playSound();
//             }}
//           >
//             HOME
//           </Link>
//         </li>

//       {categories && categories.map((category, index) => (
//         <li key={category.id} className="nav-item">
//           <Link
//             to={`/${category.name.toLowerCase().replace(/\s+/g, '-')}`}
//               className={`nav-links ${activeCategory === category.id ? 'active' : ''}`}
//               onClick={() =>{
//                 setActiveCategory(category.id)
//                 playSound();}}
//           >
//             {category.name.toUpperCase()}
//           </Link>
//         </li>
//       ))}

//         {/* <li className="nav-item">
//           <Link to="/products" className="nav-links">CATEGORIES</Link>
//         </li> */}

//         <li className="nav-item">
//           <Link to="/contacts" className={`nav-links ${activeCategory === 'contacts' ? 'active' : ''}`}
//               onClick={() =>{
//                 setActiveCategory('contacts')
//                 playSound();}}>CONTACT</Link>
//         </li>
//                 <li className="nav-item">
//           <Link to="/arcade" className={`nav-links ${activeCategory === 'arcade' ? 'active' : ''}`}
//               onClick={() =>{
//                 setActiveCategory('arcade')
//                 playSound();}}>ARCADE</Link>
//         </li>
//       </ul>
//     </nav>
//   );
// };

// export default Navbar;

import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "../styles/Navbar.css";
import { useProducts } from "../hooks/useProducts";
import { playSound } from "../utils/productUtils";
import useOrientation from "../hooks/useOrientation";
import useDeviceType from "../hooks/useDeviceType";

const Navbar = () => {
  const { categories } = useProducts();
  const [open, setOpen] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const location = useLocation();
  const orientation = useOrientation();
  const device = useDeviceType();

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];

    const currentCategory = categories?.find(
      (cat) => cat.name.toLowerCase().replace(/\s+/g, "-") === currentPath,
    );

    setActiveCategory(currentCategory?.id || null);
  }, [location.pathname, categories]);

  const handleClick = (id) => {
    setActiveCategory(id);
    setOpen(false);
    playSound();
  };

  return (
    <>
      <nav className="navbar">
        <div className="menu-icon" onClick={() => setOpen(!open)}>
          ☰
        </div>

        <ul className="nav-menu desktop-menu">
          <li className="nav-item">
            <Link
              to="/"
              className={`nav-links ${!activeCategory ? "active" : ""}`}
              onClick={() => handleClick(null)}
            >
              HOME
            </Link>
          </li>

          {categories?.map((category) => (
            <li key={category.id} className="nav-item">
              <Link
                to={`/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
                className={`nav-links ${
                  activeCategory === category.id ? "active" : ""
                }`}
                onClick={() => handleClick(category.id)}
              >
                {category.name.toUpperCase()}
              </Link>
            </li>
          ))}

          <li className="nav-item">
            <Link
              to="/contacts"
              className={`nav-links ${
                activeCategory === "contacts" ? "active" : ""
              }`}
              onClick={() => handleClick("contacts")}
            >
              CONTACT
            </Link>
          </li>

          {device === "desktop" && (
            <li className="nav-item">
              <Link
                to="/arcade"
                className={`nav-links ${activeCategory === "arcade" ? "active" : ""}`}
                onClick={() => handleClick("arcade")}
              >
                ARCADE
              </Link>
            </li>
          )}
        </ul>
      </nav>

      {/* MOBILE SLIDE MENU */}
      <div className={`mobile-menu ${open ? "open" : ""}`}>
        <ul>
          <li>
            <Link to="/" onClick={() => handleClick(null)}>
              HOME
            </Link>
          </li>

          {categories?.map((category) => (
            <li key={category.id}>
              <Link
                to={`/${category.name.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => handleClick(category.id)}
              >
                {category.name.toUpperCase()}
              </Link>
            </li>
          ))}

          <li>
            <Link to="/contacts" onClick={() => handleClick("contacts")}>
              CONTACT
            </Link>
          </li>

          {/* <li>
            <Link to="/arcade" onClick={() => handleClick("arcade")}>
              ARCADE
            </Link>
          </li> */}
        </ul>
      </div>

      {open && <div className="menu-overlay" onClick={() => setOpen(false)} />}
    </>
  );
};

export default Navbar;
